import { render } from "./SideNavBadge.vue?vue&type=template&id=d79a34e2"
import script from "./SideNavBadge.vue?vue&type=script&lang=js"
export * from "./SideNavBadge.vue?vue&type=script&lang=js"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__